// extracted by mini-css-extract-plugin
export default {"ConteneurInfo":"Ajouter_ConteneurInfo__9d-Q2","Formulaire":"Ajouter_Formulaire__F1n3-","btsSty":"Ajouter_btsSty__uN3Ur","fore":"Ajouter_fore__iuwVe"};